<!-- eslint-disable -->
<template lang="pug">
    .battle-container
        .battle-container__title(v-if="$route.name === 'battle:stage-results'")
            h2.battle-container__title-text {{ $i18n.t('olympiads.olympiads_processStage_stageCompleted') }}
        .battle-container__title(v-else-if="$route.meta.battleTitle === 'battle'")
            h2.battle-container__title-text {{ $i18n.t('battle.battle_layout_battle') }}
        .battle-container__title(v-else-if="$route.meta.battleTitle === 'battles'")
            h2.battle-container__title-text {{ $i18n.t('battle.battle_layout_battles') }}
        router-view
</template>

<script>
    /*eslint-disable*/
    export default {
        mounted () {
            if (window.innerWidth < 578) {
                this.$nextTick(() => {
                    let mainColumn = document.querySelector('.main-column')
                    if (mainColumn && (this.$route.name === 'battle:show')) {
                        mainColumn.style.backgroundColor = 'transparent';
                        mainColumn.style.paddingTop = 10 + 'px';
                    }
                })
            }
        },
        watch: {
            '$route.name': {
                handler (val) {
                    let mainColumn = document.querySelector('.main-column');
                    if (mainColumn
                        && (val === 'battle:show')) {
                        mainColumn.style.backgroundColor = 'transparent';
                        mainColumn.style.paddingTop = 10 + 'px';
                    } else if (mainColumn) {
                        mainColumn.style.backgroundColor = '';
                        mainColumn.style.paddingTop = '';
                    }
                }
            }
        },
        beforeRouteLeave (to, from, next) {
            let mainColumn = document.querySelector('.main-column')
            if (mainColumn) {
                mainColumn.style.backgroundColor = '';
                mainColumn.style.paddingTop = '';
            }
            next();
        }
    }
</script>

<style lang="scss">
    .battle-background {
        background:
            url('../../assets/images/battles/main-background.png'),
            linear-gradient(360deg, #FFFFFF -33.6%, #ADDAAD -4.86%, #6BBD6C 50%);
    }

    .battle-container {
        height: 100%;
        padding: 0;
    }

    .battle-container__title {
        @include stack-space($space-large);
        @include media($sm) {
            @include stack-space(0);
            @include inset-space($space-large);
        }
        text-align: center;
    }

    .battle-container__title-text {
        font-family: Appetite, serif;
        color: $x-color-white;
        font-size: 42px;
        white-space: nowrap;
        @include media($sm) {
            color: $x-color-white;
        }
    }
</style>
